<template>

    <div class="logs-component">

        <ul>
            <li v-for="log in logs">
                <h3>{{ log.created_by.name }}
                    <small>{{ log.created_at }}</small>
                </h3>
                <span v-html="log.text"></span>
            </li>
        </ul>

    </div>

</template>

<style lang="scss" scoped>
    @import '../../sass/setup';

    .logs-component {
        @include clearfix;
        h3 {
            font-size: 17px;
            font-weight: 500;
            margin-bottom: 0.5em;
            @include clearfix();
            small {
                float: right;
                opacity: 0.8;
            }
        }
        span {
            font-size: 13px;
        }
        ul {
            li {
                @include clearfix();
                background-color: #f3f3f3;
                padding: 0.7em;
                border-radius: 0.3em;
                &:nth-of-type(odd) {
                    background: #fff;
                }

            }
        }
    }

</style>


<script>
    export default {
        props: ['getUrl'],
        data() {
            return {
                logs: []
            }
        },
        watch: {
            getUrl: function () {
                this.getLogs();
            }
        },
        computed: {},
        methods: {
            getLogs() {
                var that = this;
                axios.get(this.getUrl)
                    .then(response => {
                        that.logs = response.data.data;
                    });
            }
        },
        mounted() {
            this.getLogs();
        }
    }
</script>